import {useAppContext} from '@/matic/providers/AppProvider';
import {userRoles} from '@/matic/types/roles';

/**
 * UX-only permissions for Master Data surfaces.
 * Backend enforces authz — this gates write UI for non-admin/quality roles.
 */
export function useMasterDataPermissions() {
  const {userRole} = useAppContext();
  return {
    canWrite: userRole === userRoles.admin || userRole === userRoles.quality,
  };
}
